//frontend/src/dropdownMap/cb_staff_dropdownFieldMapping.js

export const dropdownFieldsByIdx = {
    8: "Gender",
    10: "Office",
    11: "StaffType",
    12: "Category",
    13: "Topic",
};

// Topic is a cascading dropdown: each itemcode is scoped to exactly one Category
// via the DB's choice_filter column. Grouped here as [code, LA label, EN label].
const TOPIC_GROUPS = {
    "1_tot": [
        ["tot1", "ຝຶກຄູຝຶກການປຸງແຕ່ງ ແລະ ຄວາມປອດໄພ ຂອງອາຫານ", "TOT Food processing and food safety Trainning"],
        ["tot2", "ຝຶກຄູຝຶກເຕັກນິກ ການຈັດເວທີຜູ້ມີສ່ວນໄດ້-ເສຍ ທາງທຸລະກິດ", "TOT MSP Trainning"],
        ["tot3", "ເຕັກນິກ ລະບົບການຮູ້ຮຽນຜ່ານບົດບາດຍິງ-ຊາຍ", "TOT on GALS training for LWU"],
        ["tot4", "ຝຶກຄູຝຶກເຕັກນິກການສ້າງຕັ້ງກຸ່ມ", "TOT on APG formulation for staff"],
        ["tot5", "ຝຶກຄູຝຶກເຕັກນິກການປະເມີນກຸ່ມຜະລິດ", "TOT on APG assessment for staff"],
        ["tot6", "ຝຶກຄູຝຶກເຕັກນິກການການຂຽນ ບົດສະເໜີຂໍທຶນກຸ່ມ ໃຫ້ພະນັກງານເມືອງ", "TOT on APG business proposal for DAFO"],
        ["tot7", "ຝຶກຄູຝຶກເຕັກນິກການປະເມີນກຸ່ມ ໃຫ້ພະນັກງານເມືອງ", "TOT on APG assessment for DAFO staff"],
        ["tot8", "ຝຶກຄູຝຶກ ການຄຸ້ມຄອງບໍລິຫານກຸ່ມ ໃຫ້ພະນັກງານເມືອງ", "TOT on APG Mgt. techniques for DAFO"],
        ["tot9", "ຝຶກຄູຝຶກການປຸງແຕ່ງອາຫານ ໃນຄົວເຮືອນ", "TOT on Food processing (Domestic)"],
        ["tot10", "ຝຶກຄູຝຶກການສາທິດປຸງແຕ່ງອາຫານ", "TOT cooking demonstration for DAFO"],
        ["tot11", "ຝຶກຄູຝຶກເຕັກນິກການເຜີຍແຜ່ໂຄງການ ແລະ ການສ້າງແຜນພັດທະນາບ້ານ", "TOT on village orientation & planning techniques for staff"],
        ["tot12", "ຝຶກຄູຝຶກ ຄວາມຮູ້ດ້ານທຸລະກິດ", "TOT on BALI for staff (Business literacy)"],
        ["tot13", "ຝຶກຄູຝຶກເຕັກນິກການຄຸ້ມຄອງ ທະນາຄານເຂົ້າ", "TOT on Rice banks Maintenance techniques"],
        ["tot14", "ຝຶກຄູຝຶກເຕັກນິກການຮັກສາຜົນຜະລິດຫຼັງການເກັບກ່ຽວ", "TOT on post- harvest training"],
        ["tot15", "ຝຶກຄູຝຶກ ສຳລັບ 4 ບົດຮຽນໃຫ້ແກ່ວິຊາການຂັ້ນແຂວງແລະຂັ້ນເມືອງ", "TOT on 4 modules of FNS for Staff"],
        ["tot16", "ຝຶກຄູຝຶກການຢ້ຽມຢາມສວນຄົວແບບມີສວ່ນຮ່ວມ", "TOT Participatory HG visit for DAFO"],
        ["tot17", "ຝຶກຄູຝຶກການວາງແຜນພັດທະນາບ້ານໃຫ້ ພ/ງ ເມືອງ", "TOT on VOP for DAFO staff"],
        ["tot18", "ຝຶກຄູຝຶກ ວຽກງານລະບົບນ້ຳອາເນກປະສົງ ນໍ້າລິນ/ຊົນລະປະທານ", "TOT  Multi use water systems/Irrigation schemes"],
        ["tot19", "ຝຶກຄູຝຶກສິ່ງອຳນວຍຄວາມສະດວກ ໃນການປຸງແຕ່ງ ແລະ ເກັບຮັກສາອາຫານ", "TOT for Food Processing and Storage Facilities"]
    ],
    "2_training": [
        ["training1", "ຕິດຕາມ ແລະ ປະເມີນຜົນ", "M&E Techniques Training"],
        ["training2", "ການເງິນ", "Fin Techniques Training"],
        ["training3", "ຈັດຊື້-ຈັດຈ້າງ", "Procurement Techniques Trainning"],
        ["training4", "ບົດບາດຍິງ-ຊາຍ", "Gender Techniques Trainning"],
        ["training5", "ການປັບຕົວຕໍ່ການປ່ຽນແປງ ດິນຟ້າອາກາດ.", "SECAP Techniques Trainning"],
        ["training6", "ຝຶກອົບຮົມການຈັດຕັ້ງປະຕິບັດ HGSF", "Model HGSF implementation training"]
    ],
    "3_visit": [
        ["visit1", "ທັດສະນະສຶກສາການຄຸ້ມຄອງບໍລິໂຄງການ", "Study/Exchange Visits Project Mgt."],
        ["visit2", "ທັດສະນະສຶກສາການຄຸ້ມຄອງກຸ່ມຜະລິດ", "Study/Exchange Visits APG Mgt."],
        ["visit3", "ທັດສະນະສຶກສາວຽກງານສັງຄົມ, ສິ່ງແວດລ້ອມ ແລະ ການປັບຕົວຕໍ່ປ່ຽນແປງອາກາດ", "Study/Exchange Visits SECAP"],
        ["visit4", "ທັດສະນະສຶກສາການຄຸ້ມຄອງ ແລະ ແລກປ່ຽນຄວາມຮູ້", "Study/Exchange Visits KMLF"],
        ["visit5", "ທັດສະນະສຶກສາດ້ານຈຸລະວິສາຫະກິດ-ນ້ອຍ-ກາງ ແລະ ເວທີແລກປ່ຽນທາງທຸລະກິດ", "Study/Exchange Visits MSME + MSP"]
    ],
    "4_ojtraining": [
        ["ojtraining1", "ຝຶກອົບຮົມກັບວຽກຕົວຈິງ", "On-the-Job Training"]
    ],
    "5_demo": [
        ["demo1", "ວຽກງານສາທິດ", "Demonstration"]
    ],
    "6_meeting": [
        ["meeting1", "ກອງປະຊຸມຄະນະຊີ້ນຳໂຄງການ", "Project Steering committee meeting"],
        ["meeting2", "ກອງປະຊຸມວາງແຜນການ ແລະ ງົບປະມານປະຈຳປີ", "AWPB Planning workshop"],
        ["meeting3", "ກອງປະຊຸມທົບທວນປະຈຳໄຕມາດ", "Qt review meeting"],
        ["meeting4", "ກອງປະຊຸມທົບທວນປະຈຳ 6 ເດືອນ", "Semi-annual review meeting"],
        ["meeting5", "ກອງປະຊຸມທົບທວນປະຈຳ 9 ເດືອນ", "9-month review and draft AWPB review meeting"],
        ["meeting6", "ກອງປະຊຸມທົບທວນປະຈຳປີ", "Annual Review meeting"],
        ["meeting7", "ຈັດເວທີພົບປະແລກປ່ຽນ ຂອງວິສາຫະກິດ", "MSME/MSP event"],
        ["meeting8", "ຈັດປະຊຸມ ວຽກງານອົງການຈັດຕັ້ງທາງສັງຄົມ", "CSO events"],
        ["meeting9", "ກອງປະຊຸມຄະນະໂພຊະນາການຂັ້ນແຂວງ ແລະ ເມືອງ", "PNC & DNC Meeting"],
        ["meeting10", "ປະຊຸມກວດຜ່ານ ແລະ ຮັບຮອງແຜນການຜະລິດຂອງກຸ່ມ", "Validation and approval of APG plans"],
        ["meeting11", "ປະຊຸມແນະນຳ ການຈັດຕັ້ງປະຕິບັດໂຄງການ AFN2", "Project orientation of AFN2"],
        ["meeting12", "ປະຊຸມເປີດໂຄງການ", "Project launching"],
        ["meeting13", "ປະຊຸມກະກຽມ/ຮັບຮອງແຜນການປະຈຳປີ", "AWPB preparation/validation"],
        ["meeting14", "ປະຊຸມເຜີຍແຜ່ໂຄງການໃຫ້ອໍານາດການປົກຄອງບ້ານ", "Project orientation to village authority"],
        ["meeting15", "ປະຊຸມແນະນໍາການຈັດຕັ້ງປະຕິບັດໂຄງການ AFN-II", "Project Orientation for AFN-II"],
        ["meeting16", "ປະຊຸມອື່ນໆ", "Others"]
    ]
};

// Build the flat Topic dropdown option set plus a code -> parent-Category lookup
// used by the frontend to filter the option list down to the currently selected Category.
const Topic = { internal: [], LA: {}, EN: {}, groupBy: {} };
Object.entries(TOPIC_GROUPS).forEach(([categoryCode, items]) => {
    items.forEach(([code, la, en]) => {
        Topic.internal.push(code);
        Topic.LA[code] = la;
        Topic.EN[code] = en;
        Topic.groupBy[code] = categoryCode;
    });
});

export const dropdownOptions = {
    //internal values should match database stored values
    //LA and EN values are for display purpose

    Category: {
        internal: ["1_tot", "2_training", "3_visit", "4_ojtraining", "5_demo", "6_meeting"],
        LA: {
            "1_tot": "1",
            "2_training": "2",
            "3_visit": "3",
            "4_ojtraining": "4",
            "5_demo": "5",
            "6_meeting": "6"
        },
        EN: {
            "1_tot": "1",
            "2_training": "2",
            "3_visit": "3",
            "4_ojtraining": "4",
            "5_demo": "5",
            "6_meeting": "6"
        }
    },
    Topic,
    Gender: {
        internal: ["_male", "_female"],
        LA: { "_male": "ຊາຍ", "_female": "ຍິງ" },
        EN: { "_male": "Male", "_female": "Female" }
    },
    Office: {
        internal: [
            "npco", "wfp", "daec", "pafo", "dafo", "nafri", "donre", "dpwt",
            "dlwo", "dico", "pico", "dpi", "dfnc", "deso", "dho", "doic",
            "dfo", "others"
        ],

        LA: {
            "npco": "ຫ້ອງການປະສານງານສູນກາງ",
            "wfp": "ອົງການອາຫານໂລກ",
            "daec": "ກົມສົ່ງເສີມກະສິກຳ ແລະ ສະຫະກອນ",
            "pafo": "ພະແນກ ກປ ແຂວງ",
            "dafo": "ຫ້ອງການ ກປ  ເມືອງ",
            "nafri": "ສະຖາບັນຄົ້ນຄວ້າ ກປ ແລະ ພັດທະນາຊົນນະບົດ",
            "donre": "ຊັບພະຍາກອນທຳມະຊາດແລະສິ່ງແວດລ້ອມເມືອງ",
            "dpwt": "ໂຍທາທິການ ແລະ ຂົນສົ່ງ ເມືອງ",
            "dlwo": "ຫ້ອງການສະຫະພັນແມ່ຍິງເມືອງ",
            "dico": "ຫ້ອງການອຸດສະຫະກຳ ແລະ ການຄ້າເມືອງ",
            "pico": "ຫ້ອງການອຸດສະຫະກຳ ແລະ ການຄ້າແຂວງ",
            "dpi": "ຫ້ອງການແຜນການ ແລະ ການລົງທຶນເມືອງ",
            "dfnc": "ແນວລາວສ້າງຊາດເມືອງ",
            "deso": "ຫ້ອງການສຶກສາ ແລະ ກິລາເມືອງ",
            "dho": "ຫ້ອງການສາທາລະນະສຸກ ເມືອງ",
            "doic": "ຖະແຫຼງຂ່າວ, ວັດທະນະທຳ ແລະ ທ່ອງທ່ຽວ ເມືອງ",
            "dfo": "ຫ້ອງການ ການເງິນ ເມືອງ",
            "others": "ອື່ນໆ"
        },

        EN: {
            "npco": "NPCO",
            "wfp": "WFP",
            "daec": "DAEC",
            "pafo": "PAFO",
            "dafo": "DAFO",
            "nafri": "NAFRI",
            "donre": "DONRE",
            "dpwt": "DPWT",
            "dlwo": "DLWO",
            "dico": "DICO",
            "pico": "PICO",
            "dpi": "DPI",
            "dfnc": "DFNC",
            "deso": "DESO",
            "dho": "DHO",
            "doic": "DOIC",
            "dfo": "DFO",
            "others": "Others"
        }
    },
    StaffType: {
        internal: [
            "afn_ii_staff",
            "gol_staff",
            "wfp_staff",
            "nafri_staff",
            "daec_staff"
        ],

        LA: {
            "afn_ii_staff": "ພະນັກງານໂຄງການ AFN2",
            "gol_staff": "ພະນັກງານລັດ",
            "wfp_staff": "ພະນັກງານອົງການອາຫານໂລກ",
            "nafri_staff": "ພະນັກງານສະຖາບັນ ກປ",
            "daec_staff": "ພະນັກງານກົມສົ່ງເສີມ"
        },

        EN: {
            "afn_ii_staff": "AFN-II staff",
            "gol_staff": "GoL staff",
            "wfp_staff": "WFP staff",
            "nafri_staff": "NAFRI staff",
            "daec_staff": "DAEC staff"
        }
    }
};

// Reverse mapping: LA → _male etc.
// export const dropdownReverseMap = {};
// Object.keys(dropdownOptions).forEach(field => {
//     dropdownReverseMap[field] = { LA: {}, EN: {} };
//     const opts = dropdownOptions[field];
//     opts.internal.forEach(intVal => {
//         dropdownReverseMap[field].LA[opts.LA[intVal]] = intVal;
//         dropdownReverseMap[field].EN[opts.EN[intVal]] = intVal;
//     });
// });
export const dropdownReverseMap = {};
Object.keys(dropdownOptions).forEach(field => {
    dropdownReverseMap[field] = { LA: {}, EN: {} };
    const opts = dropdownOptions[field];
    opts.internal.forEach(intVal => {
        const strVal = String(intVal); // force string
        dropdownReverseMap[field].LA[opts.LA[strVal]] = strVal;
        dropdownReverseMap[field].EN[opts.EN[strVal]] = strVal;
    });
});

// Topic's reverse map is scoped by Category (same approach as cb_villagers' SpecializedTopic),
// so that identical labels in different Category groups (should any arise later) can't collide:
// [language][categoryCode][label] -> code.
dropdownReverseMap.Topic = { LA: {}, EN: {} };
Topic.internal.forEach(code => {
    const categoryCode = Topic.groupBy[code];
    ['LA', 'EN'].forEach(lang => {
        if (!dropdownReverseMap.Topic[lang][categoryCode]) {
            dropdownReverseMap.Topic[lang][categoryCode] = {};
        }
        dropdownReverseMap.Topic[lang][categoryCode][Topic[lang][code]] = code;
    });
});
